import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';

Sentry.init({
  dsn: 'https://e504e5ea8b9c4fb7a595ac07d6796cc2@sentry.urbantrout.io/8',
  integrations: [
    new Integrations.BrowserTracing({
      tracingOrigins: ['localhost', 'fuhrparkmanagement.autoplus-reifen.at'],
    }),
  ],

  tracesSampleRate: 0.2,
});
